import { type ReactNode } from 'react';

export const messageBody: ReactNode = (
	<>
		Recuerda que para poder formalizar la autorización por videoconferencia será necesario 
		que todos los intervinientes incluidos en la solicitud estén registrados en el Portal 
		Notarial del Ciudadano y dispongan de un certificado electrónico emitido por una 
		entidad incluida en la{' '}
		<a 
			href="https://eidas.ec.europa.eu/efda/trust-services/browse/eidas/tls" 
			target="_blank" 
			rel="noopener noreferrer"
		>
			TSL europea
		</a>.
	</>
);